import React from "react";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import { ServiceProviderR } from "../../../pages/service-provider/routes";
import { SmartApplyR } from "../../../pages/smart-apply/route";

export const PublishModal: React.FC<{
  isServiceProviderAccount: boolean;
  smartApply: Pick<ProcedureEntity, "id" | "publishStatus" | "orgId">;
  publish: () => Promise<void>;
  publishProcAndSmartApply: () => Promise<void>;
  onClose: () => void;
}> = ({
  isServiceProviderAccount,
  smartApply,
  publish,
  publishProcAndSmartApply,
  onClose,
}) => {
  const linkForSmartApplyProcDetail = isServiceProviderAccount
    ? ServiceProviderR.ProcedureDetail.link({
        orgId: smartApply.orgId,
        procedureId: smartApply.id,
      })
    : SmartApplyR.ProcedureDetail.link({
        id: smartApply.id,
      });
  const displayPublishBothOption = smartApply.publishStatus === "DRAFT";
  let smartApplyStatus = "";
  switch (smartApply.publishStatus) {
    case "DRAFT":
      smartApplyStatus = "下書き";
      break;
    case "BEFORE_PUBLISH":
      smartApplyStatus = "公開前";
      break;
    case "UNPUBLISHED":
      smartApplyStatus = "公開終了";
      break;
    default:
      throw new Error("invalid publish status for this component");
  }
  return (
    <form>
      <section className="modal-card-body">
        <div className="notification is-warning is-light">
          <div>
            <span className={`icon has-text-warning`}>
              <i className="fas fa-exclamation-triangle" />
            </span>
            <b>
              アクセスできないスマート申請のリンクが手続きマスタで公開されます
            </b>
          </div>
          <ul className="is-size-7 ml-5 mt-1" style={{ listStyleType: "disc" }}>
            <li>
              指定されたスマート申請は{smartApplyStatus}
              の状態です。更新する場合は
              <a
                href={linkForSmartApplyProcDetail}
                target="_blank"
                rel="noopener noreferrer"
              >
                こちら
              </a>
              から行ってください。
            </li>
            {displayPublishBothOption && (
              <>
                <li>
                  「両方とも公開する」を押下すると、スマート申請と手続きマスタの両方を即時公開します。
                </li>
                <li>
                  スマート申請を公開するとフォームなどの更新ができなくなります。設定内容を確認の上で実行してください。
                </li>
              </>
            )}
          </ul>
        </div>
      </section>
      <section className="modal-card-foot">
        <button
          type="button"
          className="button is-failure is-fullwidth"
          onClick={onClose}
        >
          キャンセル
        </button>
        {displayPublishBothOption ? (
          <>
            <button
              type="button"
              className="button is-failure is-fullwidth"
              onClick={() => {
                publish().then(onClose);
              }}
            >
              手続きマスタのみ公開する
            </button>
            <button
              type="button"
              className="button is-info is-fullwidth"
              onClick={() => {
                publishProcAndSmartApply().then(onClose);
              }}
            >
              両方とも公開する
            </button>
          </>
        ) : (
          <button
            type="button"
            className="button is-fullwidth"
            onClick={() => {
              publish().then(onClose);
            }}
          >
            公開する
          </button>
        )}
      </section>
    </form>
  );
};
